import {
  site,
  type Region,
  type Hotel,
  type Category,
} from '@/api/pageService/client';

// extra type since page-service can also return a Redirect-response which we don't support (ie. we error out)
export type Config = Region | Hotel | Category;

const api = {
  site,
};

export type {SiteParams, BlockTrustElements} from '@/api/pageService/client';

export default api;
